import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";

class Navbar extends Component {
    render() {
        let { step } = this.props;
        return (
            <nav className="navbar navbar-default">
               <div className="container-fluid">
               {
                    step !== 0 && step !== 2 ?
                        <div className="navbar-brand">
                            <button onClick={this.props.clickToBack} style={{border: "none", background: "none"}}>
                                <img src="assets/images/icon_back.svg"/>
                            </button>
                        </div>
                    : this.props.error &&
                        <div className="navbar-brand">
                            <button onClick={this.props.clickToReload} style={{border: "none", background: "none"}}>
                                <img src="assets/images/icon_back.svg"/>
                            </button>
                        </div>
               }
                <img className="logo" src="assets/images/logo-escala-negativo.png" style={{ marginLeft: `${ step === 0 ? "auto" : "0px"}`}}/>
               <div/>
               </div> 
            </nav>
        )
    }
}
export default withRouter(Navbar);



// WEBPACK FOOTER //
// ./src/commons/components/navbar.js